import React from 'react';
import { Button } from './ui/button';
import { 
  Home,
  Clock,
  Shield,
  Calendar,
  BarChart3
} from 'lucide-react';

interface ClockItBottomNavProps {
  currentScreen: string;
  // Accept a permissive handler to match setCurrentScreen
  onScreenChange: (screen: any) => void;
}

export function ClockItBottomNav({ currentScreen, onScreenChange }: ClockItBottomNavProps) {
  const tabs = [
    { id: 'dashboard', label: 'Today', icon: Home },
    { id: 'clock', label: 'Clock', icon: Clock },
    { id: 'calendar', label: 'Calendar', icon: Calendar },
    { id: 'rights', label: 'Rights', icon: Shield },
    { id: 'stats', label: 'Stats', icon: BarChart3 },
  ];

  return (
    <div className="bottom-nav fixed bottom-0 left-0 right-0 z-50">
      <div className="flex items-center justify-around py-2">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = currentScreen === tab.id;
          
          return (
            <Button
              key={tab.id}
              variant="ghost"
              onClick={() => onScreenChange(tab.id)}
              className={`flex flex-col items-center space-y-1 p-2 h-auto min-w-0 ${
                isActive 
                  ? 'text-primary' 
                  : 'text-muted-foreground hover:text-foreground'
              }`}
            >
              <Icon className={`w-5 h-5 ${isActive ? 'text-primary' : ''}`} />
              <span className={`text-xs ${isActive ? 'text-primary font-medium' : ''}`}>
                {tab.label}
              </span>
            </Button>
          );
        })}
      </div>
    </div>
  );
}